export default {
  state: {
	  test:0
  },
  mutations: { 
	  setTest(state,param){
		  state.test = param
	  }
  }
}